<template>
    <v-dialog
        v-model="dialog"
        max-width="600"
    >
        <v-card>
            <v-card-title>{{title}}</v-card-title>

            <v-card-text>
                <p
                    v-for="(paragraph, index) in paragraphs"
                    :key="index"
                >
                    {{paragraph}}
                </p>
            </v-card-text>

            <v-card-title>Type '{{required_response}}' to continue</v-card-title>

            <v-card-text>
                <v-text-field
                    :label="required_response"
                    hide-details="auto"
                    v-model="typed_message"
                    autocomplete="off"
                ></v-text-field>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    v-for="(action, index) in actions"
                    :key="index"
                    :color="action_color(index)"
                    :disabled="shouldDisable(action)"
                    text
                    @click="onAction(action)"
                >
                    {{action.text}}
                </v-btn>
            </v-card-actions>

        </v-card>

    </v-dialog>
</template>

<script>
const Validate = require('@/js/validate.js');
var Preconditions = require('@/js/Preconditions.js');

export default {

    data() {
        return {
            dialog: false,
            title: '',
            text: '',
            required_response: null,
            typed_message: '',
            after_alert: null,
            actions: [],
            paragraphs: [],
        }
    },

    created () {
        this.$event_bus.$on('confirm-with-response', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('confirm-with-response',this.showDialog);
    },

    methods: {
        shouldDisable(action)
        {
            return action.disable_until_valid
                && this.typed_message.toUpperCase() != this.required_response.toUpperCase();
        },
        showDialog(params)
        {
            this.title = params.title == null ? 'Alert' : params.title;
            this.text = params.text;
            this.paragraphs = params.text.split('\n');
            this.required_response = params.required_response;
            this.after_confirm = params.after_confirm;
            this.actions = params.actions;

            this.dialog = true;
        },

        action_color(index)
        {
            if ( index == this.actions.length -1 )
                return 'primary darken-1';

            return null;
        },

        onAction(action) {
            this.dialog = false;

            if ( this.after_confirm != null && action.value != null )
            {
                this.after_confirm(action.value);
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>